import React from 'react'
import { useIntl } from 'react-intl'
import PeopleContent from './PeopleContent'
import withAuth from '../../../components/withAuth'
import LoanPage from '../../../components/LoanPage'

const People = () => {
	const { formatMessage } = useIntl()

	return (
		<LoanPage
			page="app-loan-details"
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.people' }),
					value: 'people',
				},
			]}
		>
			<PeopleContent />
		</LoanPage>
	)
}

export default withAuth(People)
